/**
 * Set Contact Medium
 * @param {Object} payload - Contact Medium Object.
 */
export const set = ({ commit }, payload) => {
  if (payload) {
    return new Promise((resolve, reject) => {
      commit('SET_NAME', payload.name)
      commit('SET_TELEPHONE', payload.telephone || payload.phone)
      commit('SET_EMAIL', payload.email)
      commit('SET_FAX', payload.fax)
      commit('SET_DEPARTMENT', payload.department)
      commit('SET_DEPARTMENTCODE', payload.departmentCode)
      commit('SET_ACCOUNTASSIGNEDID', payload.accountAssignedId)
      resolve()
    })
  }
}
